<template>
    <div>
        <DFabs>
            <DFab
                id="download-upload-download"
                icon="download"
                :label="__('products.download_upload.download')"
                @click="download"
            />
            <DFab
                id="download-upload-upload"
                icon="upload"
                :label="__('products.download_upload.upload')"
                @click="upload"
            />
        </DFabs>
        <ProductPlanImportHistoryTable
            :imports="imports"
            index-route="products.products.download-upload"
            download-route="products.plans.import.download"
            backup-download-route="products.plans.import.download-backup"
            retry-route="products.plans.import.retry.show"
            type="product"
        />
    </div>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import { router } from '@inertiajs/vue3'
import ProductPlanImportHistoryTable from '~@/Components/Products/Products/ProductPlanImportHistoryTable.vue'

defineProps({
    imports: {
        type: Object,
        required: true,
    },
})

function download () {
    const link = document.createElement('a')
    link.href = route('products.products.download')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const upload = () => router.get(route('products.products.plans.import.create'))
</script>
